export const MenuItems = [
  {
    title: 'Home',
    url: '/home'
  },
  {
    title: 'Admin',
    url: '/admin'
  },
  {
    title: 'Review Queue',
    url: '/review_queue'
  },
  {
    title: 'URL Status',
    url: '/url_status'
  },
]